import React, { useState } from 'react';
import { AvatarImage } from '../../components/render-file/AvatarImage';
import { Customer } from '../../core/api/models';
import '../../styles/details.scss';
import '../../styles/settings.scss';
import api from '../../api';
import { useHistory } from 'react-router';
import { AddNewLandLord } from '../AddLandLord/AddNewLandLord';
import AddLandLordUserModal from '../schedule-site-visit/AddLandLordUserModal';

const PeopleTab: React.FunctionComponent<{
  propertyId: string;
}> = (props) => {
  const history = useHistory();
  const [selectedUser, setSelectedUser] = useState('');
  const [openLandLordModal, setOpenLandLordModal] = React.useState<boolean>(false);

  const selectUser = (id?: string) => {
    setSelectedUser(id || '');
    history.push(`/lead-360/${id}`);
  };

  const [memberDetails, setMemberDetails] = React.useState<Customer[]>();

  const loadDetails = async (id: string) => {
    const details = await api.customer.listCustomersByProperty(props.propertyId);
    setMemberDetails(details);
  };

  React.useEffect(() => {
    loadDetails(props.propertyId);
  }, []);

  const LandLordModal = () => {
    return (
      <div
        className="detail-poupup position-fixed top-0 w-50 h-100 overflow-auto in"
        style={{ maxWidth: "600px" }}
      >
        {renderAddLandLordHeader()}
        {/* <AddLandLordUserModal
          onClose={() => setOpenLandLordModal(false)}
          onCreateLandLord={() => setIsReload(true)}
          propertyId={currentSelectedPropertyDetail?.currentSelectedPropertyId || ''}
        /> */}
        <AddNewLandLord
          onClose={() => setOpenLandLordModal(false)}                  
          onCreateUser={() => setOpenLandLordModal(false)}
          propertyId={props.propertyId || ''}
          AddNewUser={AddLandLordUserModal}
        />
      </div>
    )
  }

  const renderAddLandLordHeader = () => {
    return (
      <div className="container-fluid bg-gray-100 border-bottom py-3 position-sticky top-0 zIndex-9">
        <div className="row align-items-center">
          <div className="col-auto" onClick={() => setOpenLandLordModal(false)}>
            <i className="icon-close text-gray-500 font-xxl cursor-pointer"></i>
          </div>
          <div className="col-auto font-base font-weight-bold">
            Add Landlord User
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <ul className="list-unstyled mb-0">
      <button
                        type="submit"
                        className="btn btn-primary font-base font-weight-bold px-5 rounded"
                        onClick={()=>setOpenLandLordModal(true)}
                        disabled={openLandLordModal}
                    >
                        Add Landlord User
                    </button>    
                        {memberDetails?.map((user, index) => {
          return (
            <li
              key={index}
              className={`border-bottom px-3 py-2 d-flex align-items-center cursor-pointer ${
                selectedUser === user?._id ? 'bg-gray-100' : ''
              } `}
              onClick={() => selectUser(user?._id)}
            >
              <div className="mr-2">
                <div className="avatar-progress avatar-progress--xs position-relative cursor-pointer">
                  <svg>
                    <circle
                      r="12"
                      cx="50%"
                      cy="50%"
                      className="default"
                    ></circle>
                    <circle
                      r="12"
                      cx="50%"
                      cy="50%"
                      className="progress"
                      stroke-dasharray="117"
                      stroke-dashoffset="75"
                    ></circle>
                  </svg>
                  <AvatarImage
                    image={user.avatar}
                    className="position-absolute left-0 right-0 top-0 bottom-0 m-auto rounded-circle"
                  ></AvatarImage>
                </div>
              </div>
              <div className="py-1">
                <h6 className="mb-0">{user.fullName}</h6>
                <p className="mb-0 font-xs text-gray-600">
                  {user.primaryEmail}
                </p>
              </div>
            </li>
          );
        })}
      </ul>
      {openLandLordModal && LandLordModal()}

    </>
  );
};

export default PeopleTab;
